import 'custom-event-polyfill';
